"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addWeighted = exports.createRando = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var fastRandoExt_1 = require("./fastRandoExt");
var arrayUtils_sidecar_1 = require("@engine/arrayUtils-sidecar");
function createRando(seed) {
    if (seed === void 0) { seed = Date.now(); }
    var _random = fastRandoExt_1.fastRandoExt(seed);
    function getNumRolls() {
        return _random.getNumRolls();
    }
    function getCurrentSeed() {
        return _random.getCurrentSeed();
    }
    function setCurrentSeed(seed) {
        _random.setSeed(seed);
    }
    function getOriginalSeed() {
        return _random.getOriginalSeed();
    }
    function f(min, max) {
        return min + (max - min) * _random.nextFloat();
    }
    function fs(max) {
        var min = -max;
        return min + (max - min) * _random.nextFloat();
    }
    function fj(n, jitter) {
        return n + fs(jitter * n);
    }
    function i(minInclusive, maxInclusinve) {
        minInclusive = Math.floor(minInclusive);
        maxInclusinve = Math.floor(maxInclusinve);
        return (minInclusive + (_random.nextInt() % (maxInclusinve - minInclusive + 1)));
    }
    function intSymmetric(maxInclusinve) {
        return i(-maxInclusinve, maxInclusinve);
    }
    function iClassic(maxExclusive) {
        maxExclusive = Math.floor(maxExclusive);
        if (maxExclusive <= 0) {
            return 0;
        }
        return i(0, maxExclusive - 1);
    }
    function randomNewSeed() {
        return i(1, 99999999);
    }
    var b = function () {
        return chance(0.5);
    };
    function chance(factor) {
        return _random.nextFloat() <= factor;
    }
    function sign() {
        return chance(0.5) ? 1 : -1;
    }
    function randomIndex(arr) {
        assert_sidecar_1.assert.t(arr.length > 0);
        var idx = i(0, arr.length - 1);
        return idx;
    }
    function sample(arr) {
        return arr[randomIndex(arr)];
    }
    function sampleAndRemove(arr) {
        assert_sidecar_1.assert.t(arr.length > 0);
        var idx = i(0, arr.length - 1);
        var s = arr[idx];
        // arr.splice(idx, 1)
        arrayUtils_sidecar_1.arrayUtils.fastSplice(arr, idx, 1);
        return s;
    }
    function shuffle(arr) {
        // TODO: rnd -- test out shuffle function
        for (var idx = arr.length - 1; idx > 0; idx--) {
            var j = i(0, idx); // i //Math.floor(Math.random() * (i + 1));
            var temp = arr[idx];
            arr[idx] = arr[j];
            arr[j] = temp;
        }
        return arr;
    }
    function sampleWeighted(arr) {
        if (arr.length === 0) {
            assert_sidecar_1.assert.failed('sampleWeighted: empty array');
            // return null
        }
        var total = 0;
        for (var i_1 = 0; i_1 < arr.length; i_1++) {
            total += arr[i_1].weight;
        }
        var randomVal = f(0, total);
        var runningTotal = 0;
        for (var i_2 = 0; i_2 < arr.length; i_2++) {
            runningTotal += arr[i_2].weight;
            if (randomVal <= runningTotal) {
                return arr[i_2].value;
            }
        }
        assert_sidecar_1.assert.failed('sampleWeighted: failed to sample');
    }
    function vec() {
        var x = f(-1, 1);
        var y = f(-1, 1);
        return { x: x, y: y };
    }
    return {
        getNumRolls: getNumRolls,
        getCurrentSeed: getCurrentSeed,
        setCurrentSeed: setCurrentSeed,
        getOriginalSeed: getOriginalSeed,
        randomNewSeed: randomNewSeed,
        // seed,
        f: f,
        fs: fs,
        fj: fj,
        i: i,
        intSymmetric: intSymmetric,
        iClassic: iClassic,
        b: b,
        chance: chance,
        sign: sign,
        randomIndex: randomIndex,
        sample: sample,
        sampleAndRemove: sampleAndRemove,
        sampleWeighted: sampleWeighted,
        shuffle: shuffle,
        vec: vec,
    };
}
exports.createRando = createRando;
function addWeighted(arr, value, weight) {
    arr.push({ value: value, weight: weight });
    return arr;
}
exports.addWeighted = addWeighted;
